import { render, staticRenderFns } from "./ActivitieProducts.vue?vue&type=template&id=0a37a6b8&scoped=true&lang=pug&"
import script from "./ActivitieProducts.vue?vue&type=script&lang=js&"
export * from "./ActivitieProducts.vue?vue&type=script&lang=js&"
import style0 from "./ActivitieProducts.vue?vue&type=style&index=0&id=0a37a6b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a37a6b8",
  null
  
)

export default component.exports